import { styled, Box, makeStyles, createStyles, Button } from '@material-ui/core';
import { FaSave as SaveIcon } from 'react-icons/fa';
import { TextInput, Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CARDS_BACKGROUND,
  DARK_CONTAINER_BORDER,
  DARK_TOOLTIP_BACKGROUND,
  LIGHT_CONTAINER_BORDER,
  LIGHT_MENUITEM_BACKGROUND,
  LIGHT_TEXTBOX_BACKGROUND,
  LIGHT_TOOLTIP_BACKGROUND,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_ICON,
} = COLORS;

export const MainCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderTop: '2px solid',
  borderTopColor: theme.palette.type === 'dark' ? DARK_CONTAINER_BORDER : LIGHT_CONTAINER_BORDER,
  alignItems: 'center',
  flex: 1,
  padding: '2px 10px 2px 15px',

  '& > p': {
    fontSize: 15,
  },

  '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
    padding: '0 5px',
  },
}));

export const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 5,
  marginLeft: 'auto',
}));

export const AddMediaButton = styled(Button)(({ theme }) => ({
  height: 36,
  border: `${PRIMARY_BUTTON_BORDER} 1px`,
  margin: '0px 10px 0 5px',
  backgroundColor: 'transparent',
}));

export const CustomTextInput = styled(TextInput)(({ theme }) => ({
  height: 36,
  backgroundColor: 'transparent',
  '& .MuiInputBase-root': {
    background: theme.palette.type === 'dark' ? `${DARK_CARDS_BACKGROUND} !important` : LIGHT_TEXTBOX_BACKGROUND,
  },
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) auto auto',
  margin: '3px 0',
  alignItems: 'center',
  gap: 10,

  [theme.breakpoints.down(1100)]: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 10px 10px',
    paddingTop: 10,

    '& .MuiFormControl-root': {
      margin: 0,
    },
  },

  [theme.breakpoints.down(700)]: {
    '& > div': {
      width: '100%',
    },
  },
}));

export const CreditItemContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0,240px) minmax(0,270px) minmax(0,270px) minmax(0,270px) minmax(0,270px) auto',
  margin: '3px 0 3px 10px',
  alignItems: 'center',
  gap: 10,

  [theme.breakpoints.down(1100)]: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 10px 10px',
    paddingTop: 10,

    '& .MuiFormControl-root': {
      margin: 0,
    },
  },
  [theme.breakpoints.down(700)]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 5,
    '& > div': {
      width: '100%',
    },
  },

  '& > p': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: 260,
    textOverflow: 'ellipsis',
    [theme.breakpoints.down(700)]: {
      maxWidth: 'unset',
      whiteSpace: 'normal',
    },
  },
}));

export const StyledSaveIcon = styled(SaveIcon)(({ theme }) => ({
  color: PRIMARY_ICON,
  height: 'auto',
  width: 'auto',
}));

export const ViewMediaButton = styled(Button)(({ theme }) => ({
  marginLeft: 10,
  border: PRIMARY_BUTTON_BORDER,
  background: 'transparent',
}));

// New Styles
export const useStyles = makeStyles((theme) =>
  createStyles({
    option: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
    },
    toolTip: {
      background: theme.palette.type === 'dark' ? DARK_TOOLTIP_BACKGROUND : LIGHT_TOOLTIP_BACKGROUND,
    },
  }),
);
